import { useEffect } from "react";

/**
 * Trigger pdf creation for pdf-service
 * @param precondition Signals/triggers pdf-creation when precondition is defined or true
 */
export const useTriggerPdfCreation = (
  consoleLogTriggerMessage: string,
  ...preconditions: Array<unknown | null | undefined>
) => {
  // log inside useEffect because useEffect runs after component is rendered
  useEffect(() => {
    if (
      preconditions !== undefined &&
      preconditions !== null &&
      preconditions.length > 0 &&
      preconditions.every(
        (precondition) =>
          precondition !== undefined &&
          precondition !== null &&
          precondition !== false,
      )
    ) {
      // eslint-disable-next-line no-console
      console.log(consoleLogTriggerMessage);
    }
  }, [preconditions, consoleLogTriggerMessage]);
};
